<template>

  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--添加门店-->
      <div class="common-form">爱签设置（人脸身份识别验证）</div>
      <el-form-item label="域名">
        <el-input v-model="form.domian" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="APPID">
        <el-input v-model="form.appId" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="回调地址">
        <el-input v-model="form.notifyUrl" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="公钥">
        <el-input v-model="form.publicKey" type="textarea" :autosize="{ minRows: 4, maxRows: 12}" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="私钥">
        <el-input v-model="form.apiSecret" type="textarea" :autosize="{ minRows: 4, maxRows: 12}" class="max-w460"></el-input>
      </el-form-item>
      <!-- <el-form-item label="状态">
        <el-radio-group v-model="form.is_open">
          <el-radio label="0">关闭</el-radio>
          <el-radio label="1">开启</el-radio>
        </el-radio-group>
        <div style="color:#ff6f06">注：如开启则显示隐私号码拨打，关闭则不显示</div>
      </el-form-item> -->
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>

  </div>

</template>

<script>
import SettingApi from "@/api/setting.js";

export default {
  data() {
    return {
      /*form表单数据*/
      form: {
        publicKey: "", //accessKeyId
        apiSecret: "", //accessKeySecret
        notifyUrl: "",
        // is_open: "0",
        domian: "",
        appId: ""
      },
      loading: false
    };
  },
  created() {
    this.getData();
  },

  methods: {
    getData() {
      let self = this;
      SettingApi.getAcsign({}, true)
        .then(data => {
          let vars = data.data.vars.values;
          self.form = data.data.vars.values;
        })
        .catch(error => {});
    },
    //提交表单
    onSubmit() {
      let self = this;
      self.loading = true;
      let params = this.form;
      SettingApi.editAcsign(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: "恭喜你，设置成功",
            type: "success"
          });
        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>

<style>
.tips {
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/acsign/index copy.vue